<ng-content-popover
	[title]="title"
	[message]="message"
	[options]="options"
	[disabled]="disabled"
	(actionEvent)="emitAction($event)"
></ng-content-popover>
